import { linksConstants } from "../../../src/constants/linksConstants";
import PlatformLayout from "../../../src/platform/layout/PlatformLayout";
import { ApiTemplatePage } from "../../../src/platform/views/DataCatalog/RecipePage/ApiTemplatePage";

const ConnectorsPage = props => {
  return (
    <PlatformLayout>
      <ApiTemplatePage {...props} />
    </PlatformLayout>
  );
};

export const getServerSideProps = ctx => {
  const [templateId = null, sourceName = null] = ctx.params.recipesParams;
  if (!templateId && !sourceName) {
    return {
      redirect: {
        destination: linksConstants.DATA_CATALOG_RECIPES,
        permanent: false,
      },
    };
  }
  return {
    props: {
      templateId,
      sourceName,
    },
  };
};

export default ConnectorsPage;
